import type { Collection } from 'state/utils/types';
import type { LoadingStatus } from 'utils/status';

export type OrderValidation = {
  level?: string | null | undefined;
  message?: string | null | undefined;
};

export type AmendErrorType = 'rejected' | 'failed' | 'collided';

export type AmendedTrade = Readonly<{
  status: LoadingStatus;
  validations?: OrderValidation[] | null | undefined;
  errorMessage?: string;
  errorType?: AmendErrorType;
}>;

export type AmendedTradeMap = Collection<AmendedTrade>;

export const initialAmendedTradeMap = (): AmendedTradeMap => ({});

export const intialAmendedTrade = (): AmendedTrade => ({
  status: 'idle',
});
